import React, {RefObject} from 'react';
import {Form, FormControlProps} from 'react-bootstrap';
import {BsProps} from "backoffice/ui/utils/bootstrap";

export interface FormTextBaseProps extends BsProps<'input', FormControlProps> {

}

export interface FormTextBaseState {
  hasFocus: boolean
}

/**
 *
 */
export class FormTextBase<P extends BsProps<'input', FormControlProps>, S extends FormTextBaseState> extends React.PureComponent<P, S> {

  readonly _ref: RefObject<HTMLInputElement>;
  private _prevValue: string | undefined;

  constructor(props: P | Readonly<P>) {
    super(props);

    this._ref = React.createRef();

    // 初期化
    this.state = {
      hasFocus: false,
    } as S;
  }

  handleFocus = (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>) => {
    this.setState(prev => ({...prev, hasFocus: true}));

    // フォーカス取得時の値を保持
    this._prevValue = this._ref.current?.value;

    // Original
    if (this.props.onFocus) {
      this.props.onFocus.call(event.target, event);
    }

    this.selectText();
  };

  handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    this.setState(prev => ({...prev, hasFocus: false}));

    const formatted = this.format(event.currentTarget.value);
    if (event.target.value !== formatted) {


      Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set?.call(event.target, formatted);
      event.target.dispatchEvent(new Event('input', {bubbles: true}));
    }

    // Original
    if (this.props.onBlur) {
      this.props.onBlur.call(event.target, event);
    }
  }

  handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {

    // Original
    if (this.props.onKeyDown) {
      this.props.onKeyDown.call(event.target, event);
    }

    // 値編集キャンセル（フォーカス取得時の値に戻す）
    if (event.key === 'Escape') {
      if (this._ref.current) {
        this._ref.current.value = this._prevValue ?? '';
        this.selectText();
      }
    }
  };

  format = (input: string): string => {
    return input;
  }

  selectText = () => {
    this._ref.current?.select();
  };


  controlProps() {
    return {
      autoComplete: 'off',
      ...this.props,
      onFocus  : this.handleFocus,
      onBlur   : this.handleBlur,
      onKeyDown: this.handleKeyDown,
      ref      : this._ref
    }
  }

  render() {
    return (
        <Form.Control {...this.controlProps()}/>
    );
  }
}
